import React from "react";
import "./Projects.css";
import { useLanguage } from "../context/LanguageContext";
import { SERVICE_IMAGES } from "../config/serviceImages";

const projectsData = [
  { id: 1 },
  { id: 2 },
  { id: 3 },
  { id: 4 },
  { id: 5 },
  { id: 6 },
];

const Projects = () => {
  const { t } = useLanguage();

  const projects = projectsData.map((project, index) => {
    const translatedProject = t.projects.items[index];
    return {
      ...project,
      title: translatedProject?.title || "",
      description: translatedProject?.description || "",
      image: SERVICE_IMAGES[index] || SERVICE_IMAGES[0],
    };
  });

  return (
    <section id="projects" className="projects section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">{t.projects.title}</h2>
          <p className="section-subtitle">{t.projects.subtitle}</p>
        </div>
        <div className="projects-grid">
          {projects.map((project) => (
            <article key={project.id} className="project-card">
              <div className="project-image-wrapper">
                <img
                  src={project.image}
                  alt=""
                  className="project-image"
                  loading="lazy"
                  decoding="async"
                />
                <div className="project-image-shade" aria-hidden />
              </div>
              <div className="project-content">
                <h3 className="project-title">{project.title}</h3>
                <p className="project-description">{project.description}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
